import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function TrendingSection() {
  const trending = [...comics].slice(0, 4);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            新作推荐
          </h2>
          <p className="text-sm text-foreground-500">
            发现更多精彩漫画
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {trending.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex flex-col sm:flex-row gap-4 p-5 rounded-xl bg-background-100 hover:bg-background-100/80 transition-colors cursor-pointer border border-background-200/70"
              data-product-shop
            >
              <div className="flex-shrink-0 w-full sm:w-32">
                <div className="aspect-[3/4] sm:aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                    title={`${comic.title} - 新作推荐 - 布丁漫画网`}
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">
                  作者：{comic.author}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {comic.description}
                </p>
                <div className="flex flex-wrap items-center gap-2">
                  {comic.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}